import { render, staticRenderFns } from "./PaymentQris.vue?vue&type=template&id=6c101b24"
import script from "./PaymentQris.vue?vue&type=script&lang=js"
export * from "./PaymentQris.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./PaymentQris.vue?vue&type=style&index=0&id=6c101b24&prod&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports